import { Box, Container, Grid, Link, Typography } from '@mui/material';

export const Footer = ({ onHandleExplore, isHideOptions }) => {
    const domain = window.location.hostname;
    return (
        <Box component="footer" sx={{ bgcolor: '#00264d', color: 'white', py: 6, borderTop: '1px solid rgba(255, 255, 255, 0.2)' }}>
            <Container maxWidth="xl">
                <Grid container spacing={4}>
                    <Grid item xs={12} md={5}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                            {domain.includes('medineer.ai') ?
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 2,
                                        // background: 'linear-gradient(135deg, hsl(38 100% 50%), hsl(14 100% 60%))',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                    {/* <Typography
                                        sx={{
                                            fontSize: '2.25rem',
                                            fontWeight: 700,
                                            color: '#00264d'
                                        }}>M
                                    </Typography> */}
                                    <Box
                                        component="img"
                                        src="/logo.PNG"     // public folder image
                                        alt="Medineer Logo"
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain', // or 'cover' if you want full fill
                                        }}
                                    />
                                </Box>
                                : null}
                            <Typography variant="h5"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '2.5rem',
                                    fontWeight: 700,
                                    color: '#fff',
                                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                }}>
                                {domain.includes('medineer.ai') ? 'MEDINEER' : 'learnerFitbit'}
                            </Typography>
                        </Box>
                        <Typography
                            sx={{
                                opacity: 0.8,
                                maxWidth: 500,
                                mb: 2,
                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                fontSize: '1.6rem',
                                lineHeight: '2.4rem',
                                color: '#C9D4D8',
                                textAlign: 'left',
                            }}>India's most advanced test series platform for JEE, NEET, and MHT-CET preparation with AI-powered analytics.</Typography>
                    </Grid>
                    {isHideOptions === true ? null : (
                        <Grid item xs={6} md={2}>
                            <Typography variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    mb: 2,
                                    fontSize: '1.6rem',
                                    lineHeight: '2.4rem',
                                    color: '#ffffff',
                                    textAlign: 'left',
                                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                }}>
                                Quick Links
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

                                {['Topic Pulse', 'College Predictor', 'Test Series'].map((link) => {
                                    const href =
                                        link === 'Topic Pulse'
                                            ? '#topicPulse'
                                            : link === 'College Predictor'
                                                ? '#predictor'
                                                : undefined;
                                    const disabledPaths = [
                                        "/terms",
                                        "/disclaimer",
                                        "/privacy",
                                        "/refund",
                                        "/deliverypolicy",
                                    ];
                                    const isDisabled =
                                        // link !== "Test Series" &&
                                        disabledPaths.includes(window.location.pathname);
                                    return (
                                        <Link
                                            key={link}
                                            component={link === 'Test Series' ? 'button' : 'a'}
                                            href={isDisabled ? undefined : href}
                                            onClick={(e) => {
                                                if (isDisabled) {
                                                    e.preventDefault();
                                                    return;
                                                }
                                                if (link === "Test Series") onHandleExplore();
                                            }}
                                            underline="none"
                                            sx={{
                                                color: isDisabled ? "#7a7a7a" : "#C9D4D8",
                                                textDecoration: 'none',
                                                fontFamily:
                                                    'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                                fontSize: '1.6rem',
                                                lineHeight: '2.4rem',
                                                textAlign: 'left',
                                                cursor: isDisabled ? "not-allowed" : "pointer",
                                                transition: 'color 0.3s ease',
                                                "&:hover": {
                                                    color: isDisabled ? "#7a7a7a" : "secondary.main",
                                                },
                                            }}
                                            disabled={link !== 'Test Series' && window?.Location?.pathname === ("/terms" || "/disclaimer" || "/privacy" || "/refund" || "/deliverypolicy")}
                                        >
                                            {link}
                                        </Link>
                                    );
                                })}
                            </Box>
                        </Grid>
                    )}


                    <Grid item xs={6} md={2}>
                        <Typography variant="h6"
                            sx={{
                                fontWeight: 700,
                                mb: 2,
                                fontSize: '1.6rem',
                                lineHeight: '2.4rem',
                                color: '#ffffff',
                                textAlign: 'left',
                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            }}>
                            Privacy
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

                            <Link
                                rel="noopener noreferrer"
                                href={'/terms'}
                                target="_blank"
                                underline="none"
                                sx={{
                                    color: '#C9D4D8',
                                    textDecoration: 'none',
                                    fontFamily:
                                        'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                    fontSize: '1.6rem',
                                    lineHeight: '2.4rem',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: 'secondary.main',
                                    },
                                }}
                            >
                                Terms and conditions
                            </Link>
                            <Link
                                rel="noopener noreferrer"
                                href={'/disclaimer'}
                                target="_blank"
                                underline="none"
                                sx={{
                                    color: '#C9D4D8',
                                    textDecoration: 'none',
                                    fontFamily:
                                        'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                    fontSize: '1.6rem',
                                    lineHeight: '2.4rem',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: 'secondary.main',
                                    },
                                }}
                            >
                                Disclaimer
                            </Link>
                            <Link
                                rel="noopener noreferrer"
                                href={'/privacy'}
                                target="_blank"
                                underline="none"
                                sx={{
                                    color: '#C9D4D8',
                                    textDecoration: 'none',
                                    fontFamily:
                                        'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                    fontSize: '1.6rem',
                                    lineHeight: '2.4rem',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: 'secondary.main',
                                    },
                                }}
                            >
                                Privacy Policy
                            </Link>
                            <Link
                                rel="noopener noreferrer"
                                href={'/refund'}
                                target="_blank"
                                underline="none"
                                sx={{
                                    color: '#C9D4D8',
                                    textDecoration: 'none',
                                    fontFamily:
                                        'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                    fontSize: '1.6rem',
                                    lineHeight: '2.4rem',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: 'secondary.main',
                                    },
                                }}
                            >
                                Refund Policy
                            </Link>
                            <Link
                                rel="noopener noreferrer"
                                href={'/deliverypolicy'}
                                target="_blank"
                                underline="none"
                                sx={{
                                    color: '#C9D4D8',
                                    textDecoration: 'none',
                                    fontFamily:
                                        'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                    fontSize: '1.6rem',
                                    lineHeight: '2.4rem',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: 'secondary.main',
                                    },
                                }}
                            >
                                Delivery Policy
                            </Link>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Typography variant="h6" sx={{
                            fontWeight: 700,
                            mb: 2,
                            fontSize: '1.6rem',
                            lineHeight: '2.4rem',
                            color: '#ffffff',
                            textAlign: 'left',
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        }}>Contact</Typography>
                        <Box
                            sx={{
                                display: 'flex', flexDirection: 'column',
                                gap: 1,
                                opacity: 0.8,
                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                fontSize: '1.6rem',
                                lineHeight: '2.4rem',
                                color: '#C9D4D8',
                                textAlign: 'left',
                            }}>
                            <Typography sx={{ fontSize: '1.6rem' }}>Email: support@splayndid.com</Typography>
                            <Typography sx={{ fontSize: '1.6rem' }}>Phone: +91 78219 21518</Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 4, pt: 4, borderTop: '1px solid rgba(255, 255, 255, 0.2)', textAlign: 'center', opacity: 0.6 }}>
                    <Typography variant="body2" sx={{
                        fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        fontSize: '1.6rem',
                        lineHeight: '2.4rem',
                        color: '#C9D4D8',
                    }}>
                        &copy; 2026 Splayndid Solutions Private Limited. All rights reserved.
                        {/* &copy; 2025 {domain.includes('medineer.ai') ? 'Medineer' : 'learnerFitbit'}. All rights reserved. Powered by learningFitbit. */}
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};